import { createSlice } from '@reduxjs/toolkit';
import { loadAdminUsers } from './admin-users.middleware';
import { logout } from '../auth/auth-middleware';
import { AdminUsers } from 'api/models/response/AdminUsers';

type AdminUsersState = {
    list: AdminUsers[];
    error: string | null;
    isLoading: boolean;
    page: number;
    pageSize: number;
    totalRecords: number;
    totalPages: number;
};

const initialState: AdminUsersState = {
    list: [],
    error: null,
    isLoading: false,
    page: 1,
    pageSize: 10,
    totalRecords: 10,
    totalPages: 1,
};

const parsePaginationHeader = (xPagination: string) => {
    try {
        const correctedJSON = xPagination
            .replace(/'/g, '"')
            .replace(/False/g, 'false')
            .replace(/True/g, 'true');
        return JSON.parse(correctedJSON);
    } catch (error) {
        console.error('Failed to parse x-pagination header:', error);
        return null;
    }
};

export const adminUsersSlice = createSlice({
    name: 'admin-users',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadAdminUsers.fulfilled, (state, action) => {
                const { data, headers } = action.payload;

                state.list = data;
                state.error = null;
                state.isLoading = false;

                const xPagination = headers['x-pagination'];
                if (xPagination) {
                    const pagination = parsePaginationHeader(xPagination);
                    if (pagination) {
                        state.page = pagination.page;
                        state.pageSize = pagination.pageSize;
                        state.totalRecords = pagination.TotalRecords;
                        state.totalPages = pagination.TotalPages;
                    }
                }
            })
            .addCase(loadAdminUsers.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadAdminUsers.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.list = [];
                state.error = null;
                state.isLoading = false;
            });
    },
});

export default adminUsersSlice.reducer;
